module.exports = __webpack_public_path__ + "static/media/alberto_coello.087c3933.jpg";